import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const hasLiveConfig = Boolean(supabaseUrl && supabaseAnonKey);

export const supabase = hasLiveConfig
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null;
